import React from 'react';
import PropTypes from 'prop-types';

import {withStyles} from '@material-ui/core/styles';
import {withRouter} from 'react-router-dom';

import PageviewIcon from '@material-ui/icons/Pageview';
import ArrowUpwardRounded from '@material-ui/icons/ArrowUpwardRounded';
import ArrowDownwardRounded from '@material-ui/icons/ArrowDownwardRounded';
import {
  GroupStatsCard,
  CardStats,
} from '../index';
import {LoadingLayout} from '../../layouts-common';

import style from './style';

function CountStats(props) {
  const {
    classes,
    title,
    positiveDescription,
    negativeDescription,
    positiveValue,
    negativeValue,
    widgetKey,
    history,
    url,
  } = props;

  return (
    <GroupStatsCard
        groupName={url ? (
          <div className={classes.groupName} onClick={() => history.push(url)}>
            {title}
            <PageviewIcon />
          </div>
        ) : title}
        customCardClassName="card_fullHeight"
        content={(
          <LoadingLayout widgetKey={widgetKey}>
            <div className={classes.container}>
              <div className={classes.item}>
                <CardStats
                  description={positiveDescription}
                  borderTopColor="green"
                  value={positiveValue}
                  valueIcon={<ArrowUpwardRounded fontSize="small" />}
                />
              </div>
              <div className={classes.item}>
                <CardStats
                  description={negativeDescription}
                  borderTopColor="red"
                  value={negativeValue}
                  valueIcon={<ArrowDownwardRounded fontSize="small" />}
                />
              </div>
            </div>
          </LoadingLayout>
        )}
    />
  );
}

CountStats.propTypes = {
  title: PropTypes.string.isRequired,
  positiveDescription: PropTypes.string.isRequired,
  negativeDescription: PropTypes.string.isRequired,

  classes: PropTypes.object.isRequired,
  positiveValue: PropTypes.number,
  negativeValue: PropTypes.number,
  widgetKey: PropTypes.string.isRequired,
  url: PropTypes.string,
  history: PropTypes.object.isRequired,
};
CountStats.defaultProps = {
  url: '',
  positiveValue: 0,
  negativeValue: 0,
};

export default withStyles(style)(withRouter(CountStats));
